import React from 'react';
import { Container, ContainerSections, Content } from './style';

import star from '../../assets/star.png';
import tech from '../../assets/tech.png';
import user from '../../assets/user.png';
import web from '../../assets/web.png';

import SectionStar from './section';

function EmpretecForYou() {
  return (
    <Container>
      <Content>
        <ContainerSections>
          <SectionStar
            img={star}
            text1={'Mais'}
            bigText={'30 anos'}
            text2={'de história'}
          />

          <SectionStar
            img={tech}
            text1={'Mais'}
            bigText={'13 mil'}
            text2={'seminários'}
          />
          <SectionStar
            img={user}
            text1={'Mais'}
            bigText={'300 mil'}
            text2={'empretecos'}
          />
          <SectionStar
            img={web}
            text1={'Os brasileiros representam '}
            bigText={'63%'}
            text2={'dos empretecos no Mundo'}
          />
        </ContainerSections>
      </Content>
    </Container>
  );
}

export default EmpretecForYou;
